import React from 'react';
import Chip from '@material-ui/core/Chip';
import Avatar from '@material-ui/core/Avatar';
import PropTypes from 'prop-types';
import DailyIcon from '@material-ui/icons/Assignment';
import IncidentIcon from '@material-ui/icons/AssignmentLate';
import ResponseIcon from '@material-ui/icons/NotificationsActive';

import { KONTRA_BLUE } from '../../../styles/colors';

const TimelineChip = ({onClick, variant, legend, label, style}) => {
  let labelText;
  let icon;

  switch (variant) {
    case 'activity':
      labelText = legend ? 'Daily Activity Report' : label;
      icon = <DailyIcon style={styles.icon} color='inherit' />;
      break;
    case 'incident':
      labelText = legend ? 'Incident Report' : label;
      icon = <IncidentIcon style={styles.icon} color='inherit' />;
      break;
    case 'response':
      labelText = legend ? 'Response' : label;
      icon = <ResponseIcon style={styles.icon} color='inherit' />;
      break;
    case 'cardinal':
      labelText = legend ? 'VIP Report' : label;
      icon = <DailyIcon style={styles.icon} color='inherit' />;
      break;
  }

  return (
    <Chip
      style={{ ...styles[variant], ...style }}
      avatar={
        <Avatar style={styles.avatar}>
          {icon}
        </Avatar>
      }
      label={labelText}
      onClick={onClick}
      color='inherit'
    />
  )
};

TimelineChip.propTypes = {
  onClick: PropTypes.func,
  variant: PropTypes.oneOf(['activity', 'incident', 'response', 'vacationWatch']).isRequired,
  legend: PropTypes.bool
};

export default TimelineChip;

const styles = {
  icon: {
    color: 'white'
  },
  activity: {
    backgroundColor: KONTRA_BLUE,
    color: 'white'
  },
  incident: {
    backgroundColor: 'rebeccapurple',
    color: 'white'
  },
  cardinal: {
    backgroundColor: 'goldenrod',
    color: 'white'
  },
  response: {
    backgroundColor: 'crimson',
    color: 'white'
  },
  avatar: {
    backgroundColor: 'transparent'
  }
}